export default "__VITE_ASSET__CcCb4cdu__"